/* eslint-disable no-console */

import Vue from 'vue';
import router from '@/router';

import { unregisterDevice } from '@/plugins/push-notification';

import auth from '@it-enterprise/jwtauthentication';
auth.config({
  baseUrl: window.myConfig.GrapgQlUrl,
  onError: (e) => {
    console.log('', e.response.status, e.response.status === 400);
    switch (true) {
      case e.response && e.response.status === 400:
        auth.clearTokens();
        unregisterDevice();
        Vue.$routerCore.GoToSignIn();
        break;
      case e.response && e.response.status <= 500:
        router.push({ name: 'MaintenanceOee' });
        break;
      default:
        console.log(e);
    }
  },
});

export default auth;
